export function isLikelyNetworkError(error: Error): boolean {
  if (error.name !== 'TypeError') return false;

  const message = error.message.toLowerCase();
  return (
    message.includes('network') ||
    message.includes('failed to fetch') ||
    message.includes('network request failed') ||
    message.includes('load failed') ||
    message.includes('internet')
  );
}
